import { Link } from 'react-router-dom';

export default function Footer() {
	
	const year = new Date().getFullYear();
	
	return(
		<footer className="footer">
			<div className="footer-links">
				<Link to="mailto:hello@tungaeducation.com">Get in touch</Link>
				<a href="https://www.linkedin.com/company/tunga-education/" target="_new">LinkedIn</a>
			</div>
			<div className="footer-copyright">
				© Tunga Education, {year}
			</div>
		</footer>
	)
	
}